/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState } from "react";
import { Layout } from "../components/Layout";
import { services } from "../data/services";

const mainServices = services.filter((s) => s.menu);

export const Services = () => {
  const [hovered, setHovered] = useState(null);

  const highlights = [
    { icon: "fas fa-laptop-medical", title: "eConsult Platform", desc: "Connect with certified specialists via secure video or phone consultations." },
    { icon: "fas fa-phone-alt", title: "24/7 Doctors on Call", desc: "Immediate medical guidance, any time of day or night, wherever you are." },
    { icon: "fas fa-user-md", title: "2nd Medical Opinion", desc: "Get an independent expert review of your diagnosis and treatment plan." },
    { icon: "fas fa-hospital", title: "Specialist Referrals", desc: "Fast, coordinated referrals to specialist doctors at home and abroad." },
    { icon: "fas fa-shield-alt", title: "Secure & Private", desc: "Your health data is protected with the highest security standards." },
    { icon: "fas fa-globe", title: "International Access", desc: "Board-certified specialists in Nigeria and across the globe." },
  ];

  return (
    <Layout
      subtitle={"Our Solutions & Services"}
      title={"High Quality Healthcare Services"}
      bgimage={require("../media/pexels-skitterphoto-633850.jpg").default}
      jumpto="services"
    >
      {/* ── Service Highlights ── */}
      <section
        id="services"
        style={{
          padding: "5rem 0",
          background: "linear-gradient(180deg,#f0f9f9 0%,#fff 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div style={{ position: "absolute", width: 500, height: 500, background: "rgba(0,184,184,0.07)", borderRadius: "50%", filter: "blur(80px)", top: -150, right: -150, pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: 400, height: 400, background: "rgba(55,81,75,0.06)", borderRadius: "50%", filter: "blur(70px)", bottom: -100, left: -100, pointerEvents: "none" }} />

        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row justify-content-center" style={{ marginBottom: "3.5rem" }}>
            <div className="col-12 col-lg-7 text-center">
              <div className="section-tag">What We Offer</div>
              <div className="accent-line accent-line-center" style={{ margin: "1rem auto 1.5rem" }} />
              <h2 className="section-title-modern">
                Comprehensive <span>Telehealth Solutions</span>
              </h2>
              <p style={{ color: "#6b7280", lineHeight: 1.8 }}>
                24Telemed provides accessible, affordable healthcare services connecting patients in Nigeria with qualified medical professionals around the clock.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {highlights.map((item, i) => (
              <div key={i} className={`col-12 col-md-6 col-lg-4 card-animate-in`} style={{ animationDelay: `${i * 0.1}s` }}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    padding: "2rem",
                    boxShadow: hovered === i ? "0 25px 70px rgba(0,0,0,0.14)" : "0 10px 40px rgba(0,0,0,0.07)",
                    border: "1px solid rgba(0,184,184,0.1)",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.4s ease",
                    transform: hovered === i ? "translateY(-8px)" : "translateY(0)",
                  }}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: "linear-gradient(90deg,#37514B,#00b8b8)", borderRadius: "20px 20px 0 0" }} />
                  <div style={{ width: 56, height: 56, borderRadius: 14, background: hovered === i ? "linear-gradient(135deg,#37514B,#00b8b8)" : "rgba(0,184,184,0.1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.3rem", color: hovered === i ? "#fff" : "#00b8b8", marginBottom: "1.25rem", transition: "all 0.4s ease" }}>
                    <i className={item.icon} />
                  </div>
                  <h5 style={{ fontWeight: 700, color: "#1a2332", marginBottom: "0.6rem", fontSize: "1rem" }}>{item.title}</h5>
                  <p style={{ color: "#6b7280", fontSize: "0.88rem", lineHeight: 1.75, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 2nd Opinion Services Grid ── */}
      <section style={{ padding: "4rem 0 5rem", background: "#fff" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: "linear-gradient(90deg,#37514B,#00b8b8,#37514B)", backgroundSize: "200% auto", animation: "borderFlow 3s linear infinite" }} />
        <div className="container">
          <div className="row justify-content-center" style={{ marginBottom: "3rem" }}>
            <div className="col-12 col-lg-7 text-center">
              <div className="section-tag">2nd Medical Opinion</div>
              <div className="accent-line accent-line-center" style={{ margin: "1rem auto 1.5rem" }} />
              <h2 className="section-title-modern">
                Our Medical <span>Specialties</span>
              </h2>
              <p style={{ color: "#6b7280", lineHeight: 1.8 }}>
                Board-certified specialists available for second opinion consultations across all major medical fields.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {mainServices.map((service, i) => (
              <div key={i} className={`col-12 col-md-6 col-lg-4 card-animate-in`} style={{ animationDelay: `${i * 0.1}s` }}>
                <a
                  href={service.link}
                  style={{ textDecoration: "none", display: "block", height: "100%" }}
                >
                  <div
                    style={{
                      borderRadius: 20,
                      overflow: "hidden",
                      position: "relative",
                      height: 280,
                      boxShadow: "0 15px 50px rgba(0,0,0,0.12)",
                      transition: "all 0.4s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow = "0 30px 80px rgba(0,0,0,0.2)";
                      const img = e.currentTarget.querySelector("img");
                      if (img) img.style.transform = "scale(1.1)";
                      const overlay = e.currentTarget.querySelector(".hover-overlay");
                      if (overlay) overlay.style.opacity = "1";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.12)";
                      const img = e.currentTarget.querySelector("img");
                      if (img) img.style.transform = "scale(1)";
                      const overlay = e.currentTarget.querySelector(".hover-overlay");
                      if (overlay) overlay.style.opacity = "0";
                    }}
                  >
                    <img
                      src={service.bg}
                      alt={service.name}
                      style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.6s ease", position: "absolute", inset: 0 }}
                    />
                    {/* Always-on gradient */}
                    <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.2) 50%,transparent 100%)" }} />
                    {/* Hover overlay */}
                    <div className="hover-overlay" style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg,rgba(55,81,75,0.85),rgba(0,184,184,0.75))", opacity: 0, transition: "opacity 0.4s ease" }} />
                    {/* Number badge */}
                    <div style={{ position: "absolute", top: 16, left: 16, background: "rgba(0,184,184,0.9)", color: "#fff", width: 32, height: 32, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "0.8rem" }}>
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    {/* Content */}
                    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "1.5rem" }}>
                      <h5 style={{ color: "#fff", fontWeight: 700, margin: 0, fontSize: "1rem", textTransform: "capitalize" }}>
                        {service.name}
                      </h5>
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: "0.5rem", color: "rgba(255,255,255,0.8)", fontSize: "0.78rem", fontWeight: 600 }}>
                        View Service <i className="fas fa-arrow-right" style={{ fontSize: "0.7rem" }} />
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How It Works ── */}
      <section style={{ padding: "5rem 0", background: "linear-gradient(180deg,#f0f9f9 0%,#fff 100%)" }}>
        <div className="container">
          <div className="row justify-content-center" style={{ marginBottom: "3rem" }}>
            <div className="col-12 col-lg-7 text-center">
              <div className="section-tag">Process</div>
              <div className="accent-line accent-line-center" style={{ margin: "1rem auto 1.5rem" }} />
              <h2 className="section-title-modern">How It <span>Works</span></h2>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {[
              { step: "01", icon: "fas fa-user-plus", title: "Register", desc: "Create your free account on the 24Telemed platform in minutes." },
              { step: "02", icon: "fas fa-notes-medical", title: "Submit Details", desc: "Upload your medical records, test results, and describe your condition." },
              { step: "03", icon: "fas fa-user-md", title: "Meet a Specialist", desc: "Connect with a board-certified specialist by phone or video." },
              { step: "04", icon: "fas fa-file-medical-alt", title: "Get Your Report", desc: "Receive a comprehensive opinion report and recommended treatment plan." },
            ].map((item, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-3">
                <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
                  <div style={{ position: "relative", display: "inline-flex", marginBottom: "1.5rem" }}>
                    <div style={{ width: 70, height: 70, borderRadius: "50%", background: "linear-gradient(135deg,#37514B,#00b8b8)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem", color: "#fff", boxShadow: "0 10px 30px rgba(0,184,184,0.35)" }}>
                      <i className={item.icon} />
                    </div>
                    <div style={{ position: "absolute", top: -8, right: -8, width: 26, height: 26, background: "#37514B", color: "#fff", borderRadius: "50%", fontSize: "0.65rem", fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid #fff" }}>
                      {item.step}
                    </div>
                  </div>
                  <h5 style={{ fontWeight: 700, color: "#1a2332", marginBottom: "0.6rem", fontSize: "1rem" }}>{item.title}</h5>
                  <p style={{ color: "#6b7280", fontSize: "0.88rem", lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ padding: "5rem 0", background: "linear-gradient(135deg,#253832 0%,#37514B 50%,#1a4a42 100%)", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(rgba(0,184,184,0.08) 1px,transparent 1px)", backgroundSize: "32px 32px", pointerEvents: "none" }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row justify-content-center align-items-center g-4">
            <div className="col-12 col-lg-7">
              <h2 style={{ color: "#fff", fontWeight: 800, fontSize: "clamp(1.5rem,4vw,2.2rem)", marginBottom: "1rem", lineHeight: 1.3 }}>
                Ready to get expert medical care?
              </h2>
              <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "1rem", margin: 0 }}>
                Speak to a qualified doctor today — from the comfort of your home.
              </p>
            </div>
            <div className="col-12 col-lg-4 text-lg-end">
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "flex-start" }}>
                <a href="/contact" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#fff", color: "#37514B", padding: "1rem 1.75rem", borderRadius: 50, fontWeight: 700, textDecoration: "none", transition: "all 0.3s ease", fontSize: "0.9rem" }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.25)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
                  <i className="fas fa-envelope" /> Get In Touch
                </a>
                <a href="/home#appointment" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.12)", border: "2px solid rgba(255,255,255,0.3)", color: "#fff", padding: "1rem 1.75rem", borderRadius: 50, fontWeight: 600, textDecoration: "none", transition: "all 0.3s ease", fontSize: "0.9rem" }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.22)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; }}>
                  <i className="fas fa-calendar-check" /> Book Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
